// addBannerApi
import {
  instance as axios,
  setJwtToken,
  setMultiPartHeader,
} from '../../config/axiosInstance'

export const getConsultantPayoutApi = async (data) => {
  const endPoint =
    `/admin/transaction/payout/list` +
    '?' +
    new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

// before payout
export const getbeforeConsultantPayoutApi = async (data) => {
  const endPoint =
    `/admin/payout` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const getConsultantPayoutForExactMonthApi = async (data) => {
  const endPoint =
    `/admin/payout/specific-month` + '?' + new URLSearchParams({ ...data }).toString()
  return await axios.get(endPoint, setJwtToken())
}

export const getConsultantsWithWallet = async (params) => {
  const endPoint = `/admin/consultant/wallet`
  return await axios.post(endPoint, params, setJwtToken())
}

export const getConsultantWalletDetails = async (consultantId, params) => {
  const endPoint = `/admin/consultant/${consultantId}/wallet-details`
  return await axios.post(endPoint, params, setJwtToken())
}

// ------------------------Import  Consultant Payout------------------
export const importExcelApi = async (data) => {
  const endPoint = `/admin/transaction/payout/upload/file`
  return await axios.post(endPoint, data, setMultiPartHeader())
}

// Download Excel with period filter
export const downloadExcelWithPeriod = async (params) => {
  const endPoint = `/admin/payout/export-with-period`
  return await axios.get(endPoint, params, setJwtToken())
};

// Upload Excel with settlement
export const uploadExcelWithSettlement = async (formData, query = {}) => {
  const qs = new URLSearchParams(query).toString();
  const endPoint = `/admin/payout/upload-with-settlement${qs ? `?${qs}` : ''}`;
  return await axios.post(endPoint, formData, setMultiPartHeader());
};

// Consultant monthly payment tracking (last 6 months)
export const getConsultantMonthlyPaymentTracking = async (payload) => {
  const endPoint = `/admin/payout/monthly-payment-tracking/list`;
  return await axios.post(endPoint, payload, setJwtToken());
};

export const updateConsultantMonthlyPaymentTracking = async (payload) => {
  const endPoint = `/admin/payout/monthly-payment-tracking/update`;
  return await axios.post(endPoint, payload, setJwtToken());
};

export const listPaymentTrackingForConsultants = async (payload) => {
  const endPoint = `/admin/payout/monthly-payment-tracking/list-for-consultants`;
  return await axios.post(endPoint, payload, setJwtToken());
};

export const getSettlementTracks = async () => {
  const endPoint = `/admin/payout/settlement-tracks`;
  return await axios.get(endPoint, setJwtToken());
};

export const getSettlementLogs = async (params = {}) => {
  const query = new URLSearchParams(params).toString();
  const endPoint = `/admin/payout/settlement-logs${query ? `?${query}` : ''}`;
  return await axios.get(endPoint, setJwtToken());
};

export const getConsultantRemainingHistory = async (consultantId) => {
  const endPoint = `/admin/payout/remaining/${consultantId}`;
  return await axios.get(endPoint, setJwtToken());
};

export const updateSettlementRows = async (payload) => {
  const endPoint = `/admin/payout/settlement-rows/update`;
  return await axios.post(endPoint, payload, setJwtToken());
};

export const getWalletPayoutVisibility = async () => {
  const endPoint = `/admin/payout/wallet-visibility`;
  return await axios.get(endPoint, setJwtToken());
};

export const setWalletPayoutVisibility = async (payload) => {
  const endPoint = `/admin/payout/wallet-visibility`;
  return await axios.post(endPoint, payload, setJwtToken());
};